export const optionsSendLinkMethod = [
  {
    value: 'email',
    text: 'อีเมล',
  },
  {
    value: 'sms',
    text: 'SMS',
  },
]

export const optionsResumeRMS = [
  {
    value: 'continue',
    text: 'ต้องการ',
  },
  {
    value: 'sendLink',
    text: 'ส่งลิงก์อีกครั้ง',
  },
  {
    value: 'createLink',
    text: 'สร้างลิงก์ใหม่',
  },
]
